import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // `header` removed with the in-screen title/action row: the section title
  // and "New ticket" moved up to SupportTabs, which owns them for all three
  // ticket tabs. Leaving the style behind invites someone to re-add a second
  // button next to the one already in the action bar.
  mobileList: { padding: theme.spacing(0.5, 1.5) },
  mobileEmpty: {
    textAlign: 'center',
    padding: theme.spacing(3),
    color: theme.palette.text.secondary
  },
  // The filter row sits between the search input and the table: filters narrow
  // what search returned, and reading order should match that.
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 0, 0.5)
  },
  // marginInlineStart, not marginLeft: this panel renders in Farsi too, and a
  // physical margin puts the count on the wrong side in RTL.
  filterCount: {
    marginInlineStart: 'auto',
    color: theme.palette.text.secondary
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2)
  }
}))

export default useStyles
